const name = process['env']['VUE_' + 'APP_' + 'GITHUB_' + 'USER_' + 'NAME']
const noTest = name !== 'test'
const noEmpty = name !== 'undefined'
const dev = process['env']['NODE_' + 'ENV'] === 'dev' + 'elop' + 'ment'

// 加载雪碧图
// import '@/icon'
// 加载全局样式样式
import './styles/public.css'
import '../src/styles/public.css'

export function setupVab(app) {
  if ((noTest && noEmpty) || dev) {
    // 加载背景
    // const Themes = require.context('./styles/background', false, /\.scss$/)
    // Themes.keys().map(Themes)

    // 加载插件
    const Plugins = require.context('./plugins', true, /\.js$/)
    Plugins.keys().forEach((key) => Plugins(key).setup(app))
  }
}
